module.exports = __webpack_public_path__ + "static/media/ice-pineapple.c2d254f3.png";